// components/car-card/car-card.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoField, InfoFieldItem } from '../shared/info-field/info-field';
import { TrackClickDirective } from '../../directives/track-click.directive';

@Component({
  selector: 'app-car-card',
  standalone: true,
  imports: [CommonModule, InfoField, TrackClickDirective],
  templateUrl: './car-card.html',
  styleUrls: ['./car-card.scss']
})
export class CarCard {
  @Input() title: string = 'T-Cross Comfortline 1.0 TSI Flex 5p Aut.';
  @Input() anoModelo: string = '2024';
  @Input() anoFabricacao: string = '2023';
  @Input() tipoUso: string = 'Particular';
  @Input() carImage: string = '';
  @Input() entrada: string = 'R$ 15.000,00';
  @Input() saldoParcelas: string = 'R$ 1.456,00';
  @Input() parcelas: string = '36x';

  // NOVO: Output para emitir o evento de clique
  @Output() contactClick = new EventEmitter<void>();

  get hasCarImage(): boolean {
    return Boolean(this.carImage?.trim());
  }

  // Dados para o info-field
  get infoFieldData(): InfoFieldItem[] {
    return [
      {
        type: 'text',
        title: 'Ano modelo',
        info: this.anoModelo
      },
      {
        type: 'text',
        title: 'Ano da fabricação',
        info: this.anoFabricacao
      },
      {
        type: 'text',
        title: 'Tipo de uso',
        info: this.tipoUso
      }
    ];
  }

  // NOVO: Método para lidar com o clique do botão
  onContactClick() {
    this.contactClick.emit();
  }
}
